/* global MicroModal */
MicroModal.init({
  disableFocus: true,
});

function triggerModal(modalId) {
  MicroModal.show(modalId);
}

const reminder = document.querySelector('input[id="reminder"]')
if(reminder) {
  reminder.addEventListener('change', function () {
    const emailField = document.getElementById('email-field');
    emailField.style.display = this.checked ? 'block' : 'none';
  });
}

// MicroModal closes on any click whose target's *immediate parent* has
// data-micromodal-close (i.e. the overlay) — so clicking directly on
// .modal__container itself (gaps/whitespace not covered by a child element)
// closes the modal, even though it's visually "inside" it. Stop only those
// clicks from bubbling to MicroModal's listener. Clicks on descendants are
// left alone: they don't trigger MicroModal's close, and swallowing them
// would break document-level delegated handlers (tooltips, chosen dropdowns)
// for any content rendered inside a modal.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.modal__container').forEach((container) => {
    container.addEventListener('click', (event) => {
      if (event.target === container) {
        event.stopPropagation();
      }
    });
  });
});
